<template>
  <div class="configuration-sidepanel-basic px-4">
    <b-row class="d-flex align-items-center mb-2">
      <b-col class="d-flex align-items-center">
        <span class="ap-title ap-title__main ml-1 mb-2">
          <i
            class="mr-2"
            :class="icon"
            aria-hidden="true"
          />{{ sidepanelTitle }}
        </span>
      </b-col>
      <b-col
        cols="auto"
        class="d-flex justify-content-end"
      >
        <div>
          <b-button
            v-shortkey="['shift', 'esc']"
            class="btn__icon btn__icon--primary p-0"
            @shortkey="closeConfigurationSidepanel"
            @click="closeConfigurationSidepanel"
          >
            <i
              class="far fa-times"
              aria-hidden="true"
            />
          </b-button>
        </div>
      </b-col>
    </b-row>
    <b-row class="my-2">
      <b-col cols="12">
        <div class="form-label">
          <label>{{ $tc('configuration.sections.association', 1) }}</label>
        </div>
        <vt-combo-select
          v-model="selected"
          track-by="value"
          label="text"
          :options="getCombo"
          :allow-empty="false"
          @select="select"
        />
      </b-col>
    </b-row>
    <b-row class="my-2">
      <b-col class="d-flex align-items-center mt-3">
        <span class="dark">{{ `${internalList.length} ${$tc(selected.key, internalList.length)}` }}</span>
      </b-col>
    </b-row>
    <div
      v-if="internalList"
      class="px-3 scroll-area mt-4"
    >
      <b-row
        v-for="(association, index) in internalList"
        :key="index"
        class="tech-row bottom-bordered py-2"
      >
        <b-col>
          {{ association.name }}
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import i18n from '@/lang/i18n'

export default {
    name: 'ConfigurationSidepanelBasic',
    components: { },
    props: {
        sidepanelTitle: String,
        icon: String,
        list: { type: Array, default: () => { return [] } },
        hasTabs: { type: Boolean, default: false },
        edition: { type: Object, default: null }
    },
    data() {
        return {
            internalList: [],
            combo: [],
            selected: {}
        }
    },
    computed: {
        getCombo() {
            return this.list.map((itemList) => {
                return { value: itemList.key, text: i18n.tc(itemList.translatedName, 1), key: itemList.translatedName }
            })
        }
    },
    watch: {
        list() {
            this.selected = this.getCombo && this.getCombo[0]
            this.select(this.selected)
        }
    },
    methods: {
        closeConfigurationSidepanel() {
            this.$emit('closeConfigurationSidepanelBasic')
        },
        select(elementSelected) {
            const foundList = this.list.find((list) => list.key === elementSelected.value)
            this.internalList = foundList && foundList.data
        }
    }
}
</script>

<style lang="scss">
    .configuration-sidepanel-basic .title {
        font-size: font-size(big);
        color: vt-color(primary);
    }

    .configuration-sidepanel-basic .tech-row {
        border-bottom: 1px solid rgb(209, 209, 209);
        font-size: font-size(small);
    }

    .configuration-sidepanel-basic .scroll-area{
        height: calc(100vh - 220px);
        overflow-y: auto;
        overflow-x: hidden;
    }

    @media (max-width: 1300px) {
        .configuration-sidepanel-basic .title {
            font-size: font-size(normal);
            color: vt-color(primary);
        }

        .configuration-sidepanel-basic .scroll-area{
            height: calc(100vh - 206px);
            overflow-y: auto;
            overflow-x: hidden;
        }
    }
</style>

<style lang="scss">
    .configuration-sidepanel-basic .vt-tabs .nav-tabs .nav-link.active,
    .vt-tabs--small .nav-tabs .nav-link.active {
        border-bottom: 2px solid vt-color(primary);
    }

    .configuration-sidepanel-basic .vt-tabs .nav-tabs .nav-link,
    .vt-tabs--small .nav-tabs .nav-link {
        border-bottom: 2px solid transparent;
    }

    .configuration-sidepanel-basic .vt-tabs .nav-tabs .nav-link,
    .vt-tabs--small .nav-tabs .nav-link i {
        font-size: font-size(very-normal);
    }
</style>
